// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Search: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
            <path
                fill="currentColor"
                d="M19.6967004,18.3984375 L14.4609202,13.1640625 C15.5940369,11.7773438 16.2192046,10.0312495 16.2192046,8.125 C16.2192046,3.63671899 12.5803372,0 8.09202347,0 C3.60370971,0 0,3.63789082 0,8.125 C0,12.6121092 3.63848465,16.25 8.09202406,16.25 C9.9983954,16.25 11.7473027,15.589453 13.1324393,14.4906247 L18.3682195,19.7249997 C18.5870284,19.9101567 18.8292802,20 19.0676257,20 C19.3059712,20 19.5474419,19.9084377 19.7306943,19.7253513 C20.0952448,19.3593752 20.0952448,18.7656248 19.696701,18.3984375 L19.6967004,18.3984375 Z M1.87551169,8.125 C1.87551169,4.6789062 4.68017061,1.875 8.12718951,1.875 C11.5742084,1.875 14.3788673,4.6789062 14.3788673,8.125 C14.3788673,11.5710938 11.5742084,14.375 8.12718951,14.375 C4.68017061,14.375 1.87551169,11.570313 1.87551169,8.125 Z"
            />
        </svg>
    );
};

export default React.memo(Search);
